import React, { useState, useEffect } from 'react';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { navigate } from 'gatsby';
import ToggleSelect from '../../../../common/components/ToggleSelect/ToggleSelect';
import PopUp from '../../../../common/components/PopUp/PopUp';
import developer_icon from '../../../../images/icons/UserKycIcons/developer_icon.svg';
import individual_icon from '../../../../images/icons/UserKycIcons/individual_icon.svg';
import initialImg from '../../../../images/icons/upload_new.svg';
import GlobalUploadComp from '../../../../common/components/GlobalUploadComp/GlobalUploadComp';
import CircularLoading from '../../../../common/components/CircularLoading/CircularLoading';

import {
  sellerDocUpload,
  sellerDocUploaded,
  UploadFileToS3,
  getLeadProertyDetails
} from '../../../../common/constants/api';
import { useEffectDepChange } from '../../../../hooks/useEffectDepChange';
import styles from './Seller.module.css';
import IndividualSeller from './IndividualSeller';
import { saveSellerDetails } from '../../../../common/constants/api';
import { ShowGetImage } from '../../../../common/components/ShowGetImage/ShowGetImage';

import _ from 'lodash';

let sellerKycUserId = '';

export const getSellerKycUserId = () => sellerKycUserId;

const validationSchema = Yup.object().shape({
  file: Yup.array().when('hasGetDoc', {
    is: false,
    then: Yup.array()
      .when('who_Is_seller', {
        is: 'Individual',
        then: Yup.array()
          .min(2, 'must upload both the files')
          .required('file is required')
          .of(Yup.string().required())
      })
      .when('who_Is_seller', {
        is: 'Developer',
        then: Yup.array()
          .required('file is required')
          .of(Yup.string().required())
      })
  }),
  developerName: Yup.string().when('who_Is_seller', {
    is: 'Developer',
    then: Yup.string().required('Required')
  }),
  projectName: Yup.string().when('who_Is_seller', {
    is: 'Developer',
    then: Yup.string().required('Required')
  }),
  sellerName: Yup.string().when('who_Is_seller', {
    is: 'Individual',
    then: Yup.string().required('Required')
  }),
  professionType: Yup.string().when('who_Is_seller', {
    is: 'Individual',
    then: Yup.string().required('Required')
  })
});

const Seller = ({
  getData,
  submitHandler,
  propValues,
  lead_Id,
  sectionValues,
  setFormValues
}) => {
  const [who_Is_seller, setWhoIsSeller] = useState('');
  const [loading, setLoading] = useState(false);
  const [sellerKycID, setSellerKYCID] = useState('');
  const [LoadingFail, setLoadingFail] = useState(false);
  const [docUploaded, setDocUploaded] = useState(false);
  const [show, setShow] = useState(true);
  const [isAgreeUploaded, setIsAgreeUploaded] = useState(false);
  const [isDeedUploaded, setIsDeedUploaded] = useState(false);
  const [docUploadError, setDocUploadError] = useState(false);
  const [submitErrMsg, setSubmitErrMsg] = useState('');
  const { seller_container, seller_details_container } = styles;
  const [isSubmiting, setSubmitting] = useState(false);
  const [isGetOver, setGetOver] = useState(false);
  const [getAgreementDoc, setGetAgreementDoc] = useState('');
  const [editAgreementDoc, setEditAgreeDoc] = useState(false);
  const [getDeedDoc, setGetDeedDoc] = useState('');
  const [editDeedDoc, setEditDeedDoc] = useState(false);

  const [initialValue, setInitialValueState] = useState({
    Developer: {
      developerName: getData?.devDetails?.name || '',
      projectName: getData?.devDetails?.projectName || '',
      RERA_Number: getData?.devDetails?.reraNumber || ''
    },
    Individual: {
      sellerName: '',
      professionType: ''
    }
  });
  let dep = [];

  return (
    <Formik
      initialValues={{
        file: [],
        imgUrl: [],
        hasGetDoc: false,
        ...(initialValue[who_Is_seller] || initialValue.Developer),
        who_Is_seller
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setSubmitting(true);
      }}
    >
      {propsFromFormik => {
        const {
          values: data,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          handleSubmit,
          setFieldTouched,
          setFieldError,
          isSubmitting
        } = propsFromFormik;

        function onChangeSeller(anyvalue) {
          setWhoIsSeller(anyvalue);
        }

        //setting formValues to the devDetails
        useEffect(() => {
          setFormValues(data);
        }, [data]);

        // resetting the file
        useEffect(() => {
          return () => {
            data.file = [];
            data.imgUrl = [];
          };
        }, []);

        const validationFields = [data.file[0], data.file[1]];
        const fileUploader = async index => {
          setShow(true);
          setLoading(true);
          setDocUploaded(false);
          setDocUploadError(false);
          let docId, url, fileName;
          if (index === 0) {
            fileName = 'sale-agreement';
          } else {
            fileName = 'sale-deed';
          }

          await sellerDocUpload(lead_Id, fileName)
            .then(res => {
              url = res.url;
              docId = res.requestId;
              UploadFileToS3(url, data.file[index][0], {
                'Content-Type': `${data.file[index][0].type}`
              })
                .then(res => {
                  sellerDocUploaded(lead_Id, fileName, docId)
                    .then(res => {
                      setDocUploaded(true);
                      if (index === 0) setIsAgreeUploaded(true);
                      else setIsDeedUploaded(true);
                    })
                    .catch(err => {
                      setDocUploadError(true);
                    });
                })
                .catch(err => {
                  setDocUploadError(true);
                });
            })
            .catch(err => {
              setDocUploadError(true);
            });
        };

        //get
        useEffect(() => {
          getLeadProertyDetails(lead_Id)
            .then(async res => {
              if (res) {
                if (res.sellerType === 'DEVELOPER') setWhoIsSeller('Developer');
                if (res.saleAgreementUrl?.links[0]?.url || false) {
                  await setGetAgreementDoc(res.saleAgreementUrl.links[0].url);
                  await setFieldValue('hasGetDoc', true);
                }
                if (res.saleDeedUrl?.links[0]?.url || false) {
                  await setGetDeedDoc(res.saleDeedUrl.links[0].url);
                  await setFieldValue('hasGetDoc', true);
                }
                await setGetOver(true);
              }
            })
            .catch(err => {
              setGetOver(true);
            });
        }, [lead_Id]);

        dep = useEffectDepChange({ ...validationFields });

        // making the code easy

        useEffect(() => {
          if (dep?.length > 0 && dep[0][2] !== undefined) {
            fileUploader(parseInt(dep[0][0]));
          }
        }, [dep]);
        // popUp handlers
        const applyCondtn = () => {
          if (docUploaded || docUploadError || loading || isSubmiting)
            return true;
        };
        useEffect(() => {
          if (docUploadError || docUploaded || LoadingFail) setLoading(false);
        }, [docUploaded, docUploadError, LoadingFail]);

        const propsRenderer = () => {
          let props = {};
          if (docUploaded) {
            props.type = 'success';
            props.text = 'Document uploaded successfully';
            props.autoClose = true;
            return props;
          }

          if (docUploadError) {
            props.type = 'fail';
            props.text = 'Error uploading the file, please try again ';
            props.autoClose = true;
            return props;
          }
          if (LoadingFail) {
            props.type = 'fail';
            props.text = 'Oops! something went wrong, please try again. .';
            props.autoClose = true;
            return props;
          }

          if (loading) {
            props.type = 'loading';
            props.text = 'Uploading document. . . ';
            return props;
          }
          if (isSubmiting) {
            props.type = 'loading';
            props.text = 'Submitting Details. . ';
            return props;
          }
        };

        async function saveSeller() {
          let body = {
            name: {
              firstName: data?.sellerName,
              middleName: '',
              lastName: ''
            },
            professionType: data?.professionType
          };

          if (who_Is_seller === 'Individual') {
            setSubmitting(true);
            const sellerRes = await saveSellerDetails(
              lead_Id,
              propValues.loneTypeID,
              body
            );
            if (!sellerRes.isAxiosError) {
              // setLoading(false);
              await setSellerKYCID(sellerRes?.kycUserId);
              sellerKycUserId = sellerRes?.kycUserId;
              await submitHandler();
            } else {
              setSubmitting(false);
              setLoadingFail(true);
              setSubmitErrMsg(
                sellerRes?.data?.message ||
                  'Something went wrong! please try again'
              );
            }
          } else {
            submitHandler();
          }
        }

        return isGetOver ? (
          <React.Fragment>
            {applyCondtn() && (
              <PopUp {...propsRenderer()} setShow={setShow} show={show} />
            )}

            <Form
              autoComplete="off"
              onSubmit={handleSubmit}
              className="pt-2 sm:px-5 "
            >
              <div className={`${seller_container} md:bg-white my-3 mx-3`}>
                <div className="text-black-850 font-medium font-roboto text-base py-4">
                  Who is the seller?
                </div>

                <div className="flex">
                  <div className="pr-6 flex flex-col items-center cursor-pointer">
                    <ToggleSelect
                      img={developer_icon}
                      name="who_Is_seller"
                      value="Developer"
                      checked={who_Is_seller === 'Developer'}
                      onChange={e => {
                        handleChange(e);
                        onChangeSeller(e.target.value);
                      }}
                    />
                    <p
                      className={
                        (who_Is_seller === 'Developer' ? 'text-teal ' : '') +
                        ' hover:text-teal py-2'
                      }
                    >
                      Developer
                    </p>
                  </div>
                  <div className="flex flex-col items-center cursor-pointer">
                    <ToggleSelect
                      img={individual_icon}
                      name="who_Is_seller"
                      value="Individual"
                      checked={who_Is_seller === 'Individual'}
                      onChange={e => {
                        handleChange(e);
                        onChangeSeller(e.target.value);
                      }}
                    />
                    <p
                      className={
                        (who_Is_seller === 'Individual' ? 'text-teal ' : '') +
                        ' hover:text-teal py-2'
                      }
                    >
                      Individual
                    </p>
                  </div>
                </div>
                {/* ///condition based */}
                {who_Is_seller === 'Developer' && (
                  <div className="py-6">
                    <div className="text-black-500 font-medium font-roboto text-base py-4">
                      Developer Details
                    </div>
                    <div className={`${seller_details_container} pt-6`}>
                      <div className="mb-10">
                        <CommonInput
                          name="developerName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={data.developerName}
                          stylesContainer={{
                            maxWidth: '100%'
                          }}
                          legendName="Developer Name"
                          error={touched.developerName && errors.developerName}
                          errorMsg={errors.developerName}
                          touched={touched.developerName}
                        />
                      </div>

                      <div className="mb-10">
                        <CommonInput
                          name="projectName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={data.projectName}
                          stylesContainer={{
                            maxWidth: '100%'
                          }}
                          legendName="Project Name"
                          error={touched.projectName && errors.projectName}
                          errorMsg={errors.projectName}
                          touched={touched.projectName}
                        />
                      </div>
                      <div className="mb-10">
                        <CommonInput
                          name="RERA_Number"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={data.RERA_Number}
                          stylesContainer={{
                            maxWidth: '100%'
                          }}
                          legendName="RERA Number"
                          error={touched.RERA_Number && errors.RERA_Number}
                          errorMsg={errors.RERA_Number}
                          touched={touched.RERA_Number}
                        />
                      </div>
                    </div>
                    {/* /////////upload */}
                    <div className="flex justify-center md:justify-start md:flex-wrap">
                      {getAgreementDoc && !editAgreementDoc ? (
                        <div className="ml-2 mt-2">
                          <p className="mb-3 text-grey-50">Sale Agreement</p>
                          <ShowGetImage
                            img={getAgreementDoc}
                            setEdit={setEditAgreeDoc}
                          />
                        </div>
                      ) : (
                        <div>
                          <p className="pb-4">Upload Sale Agreement</p>
                          <div
                            className="bg-white  rounded-lg border border-navy-200 md:border-none
                        py-9 pl-11 pr-5  md:py-0 md:pl-0 md:pr-0"
                          >
                            <GlobalUploadComp
                              data={data}
                              imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                              errors={errors}
                              touched={touched}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              setFieldValue={setFieldValue}
                              setFieldTouched={setFieldTouched}
                              setFieldError={setFieldError}
                              initialImg={initialImg} // initial image
                              subInst="Click here to upload"
                              subtext="CHOOSE FILE"
                            />
                          </div>
                        </div>
                      )}
                    </div>

                    {/* ///end condition based */}
                  </div>
                )}

                {/* ////for IndividualSeller */}
                {who_Is_seller === 'Individual' && (
                  <IndividualSeller
                    getAgreementDoc={getAgreementDoc}
                    editAgreementDoc={editAgreementDoc}
                    setEditAgreeDoc={setEditAgreeDoc}
                    getDeedDoc={getDeedDoc}
                    editDeedDoc={editDeedDoc}
                    setEditDeedDoc={setEditDeedDoc}
                    {...propsFromFormik}
                    lead_Id={lead_Id}
                    loanTypeId={propValues.loneTypeID}
                  />
                )}
                <div>
                  <button
                    type="submit"
                    disabled={!_.isEmpty(errors) || !who_Is_seller}
                    onClick={() => saveSeller()}
                    className="submitButton w-56"
                  >
                    Next
                  </button>
                  <p className="text-red-100 my-2 text-center text-base">
                    {submitErrMsg}
                  </p>
                </div>
              </div>
            </Form>
          </React.Fragment>
        ) : (
          <div className={'w-full mt-10 mx-auto'}>
            <CircularLoading />
          </div>
        );
      }}
    </Formik>
  );
};

export default Seller;
